import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  detailContent: {
    justifyContent: 'end',
    fontWeight: 'bold',
    textAlign: 'end',
    minWidth: 'initial !important'
  },

  detailRoot: {
    '.ant-descriptions-item-container': {
      flexWrap: 'wrap'
    }
  }
}))
